import React from 'react';

import {Icon, Icons, Sizes} from '@pb/kit-component-icon';
import {Group} from '@pb/kit-component-group';
import {hashedClasses} from '@pb/kit-util-with-css-module';

import {FlatButton} from '../flat-button/flat-button.component';
import styles from './dropdown-compound-button.component.module.styl';

import type {FlatButtonProps} from '../flat-button/flat-button.component';


const classes = hashedClasses(styles);

export interface DropdownCompoundButtonProps {
    /**
     * The primary button properties
     */
    primaryButton?: FlatButtonProps,
    /**
     * The secondary button properties
     */
    secondaryButton?: FlatButtonProps,
}


/**
 * @description The `DropdownCompoundButton` component is a combination of two buttons. The primary action enables one-click downloads,
 * while the secondary action opens a popup component with additional options
 *
 * ## Features
 * - Provides two buttons with distinct roles
 * - Primary button triggers the main action
 * - Secondary button opens a popup component with additional options
 *
 * @see https://storybook.dev.pitchbookdata.com/?path=/docs/buttons-button-dropdown-compound-button--documentation
 */
export function DropdownCompoundButton(props: DropdownCompoundButtonProps) {
    const {secondaryButton, ...compoundButtonProps} = props;

    const secondaryButtonProps = {
        'children': <Icon type={Icons.ANGLE_DOWN} size={Sizes.Size_14}/>,
        'aria-label': 'Open',
        'className': classes['dropdown-compound-secondary-button'],
        ...secondaryButton,
    };

    return (
        <Group gap="none">
            <FlatButton
                {...compoundButtonProps.primaryButton}>
                <strong>
                    {compoundButtonProps.primaryButton?.children}
                </strong>
            </FlatButton>
            <div className={classes.divider}/>
            <FlatButton {...secondaryButtonProps}/>
        </Group>
    );
}
